export const appServer = process.env.REACT_APP_ADMIN_URL || 'https://stg-admin.day.io';
export const superAdminApiServer = process.env.REACT_APP_API_SUPERADMIN || 'http://0.0.0.0:3001' || 'https://stg-sadmin-api.day.io';

/** Creating and declining punches from Dev Tools works only on development and staging. Read at call time so tests can flip it. Only the string 'true' enables. */
export const isDevToolsPunchesEnabled = (): boolean => process.env.REACT_APP_DEV_TOOLS_PUNCHES_ENABLED === 'true';
